import PrimaryCell from "../../../../../../ui/Table/Cells/PrimaryCell";
import LinkCell from "../../../../../../ui/Table/Cells/LinkCell";
import ButtonsCell from "../../../../../../ui/Table/Cells/ButtonsCell";

export const columns = [
  {
    dataField: "name",
    caption: "Наименование",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "description",
    caption: "Описание",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "source",
    caption: "Источник",
    dataType: "string",
    cellRender: LinkCell
  },
  {
    type: "buttons",
    cellRender: ButtonsCell,
    width: 110
  }
];
